import { render, staticRenderFns } from "./editorganization.vue?vue&type=template&id=045315f4&scoped=true&"
import script from "./editorganization.vue?vue&type=script&lang=js&"
export * from "./editorganization.vue?vue&type=script&lang=js&"
import style0 from "./editorganization.vue?vue&type=style&index=0&id=045315f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045315f4",
  null
  
)

export default component.exports